import { $, findTarget, findParent, dataExist, translationGuard } from '../utils/Utils';
import endPoint from '../utils/end-points';
import imgLoader from './img-loader';
import select from './select';
import range from './range';

require('es6-promise').polyfill();
const axios = require('axios');

const premise = (() => {
  const config = {
    triggerCN: 'js-premiseTrigger',
    triggers: [...$('.js-premiseTrigger')],
    targetCN: 'js-premiseTarget',
    parentCN: 'js-premiseParent',
    tolken: false,
  };

  const getOptions = (trigger) => {
    // get the [name] and the value of each trigger
    const parent = findParent(trigger, config.parentCN);
    const triggers = [...parent.querySelectorAll(`.${config.triggerCN}`)];
    const options = {};

    triggers.forEach((t) => {
      // some triggers are select, some are rangers
      if (t.classList.contains('select')) {
        const key = t.querySelector('select').getAttribute('name');
        options[key] = select.getValue({ parent: t, disablePlaceholder: true });
      } else if (t.classList.contains('js-range')) {
        const key = t.getAttribute('name');
        options[key] = range.getValue({ ranger: t });
      }
    });

    return options;
  };

  const createMarkup = premises => premises.map((p, i) => `
      <li class="grid__column -ipad-6 -macbook-4">
        <a href="${p.link}" class="tileProduct -ad" style="animation-delay: ${(i - 1) * 100}ms;">
          ${(dataExist(p, 'image')) ? `<div class="tileProduct__img imgLoader js-imgLoadTrigger imgLoader__placeholder" ${(dataExist(p.image, 'link')) ? `data-href="${p.image.link}"` : ''} ${(dataExist(p.image, 'alt')) ? `alt="${p.image.alt}"` : ''}></div>` : ''}
          <div class="tileProduct__content">
            ${(dataExist(p, 'title')) ? `<h1 class="tileProduct__title"><span>${translationGuard(p.title)}</span></h1>` : ''}
            ${(dataExist(p, 'location') || dataExist(p, 'type') || dataExist(p, 'size')) ? `
              <ul class="tileProduct__list">
                ${(dataExist(p, 'location')) ? `<li class="tileProduct__listItem">${p.location}</li>` : ''}
                ${(dataExist(p, 'type')) ? `<li class="tileProduct__listItem">${p.type}</li>` : ''}
                ${(dataExist(p, 'size')) ? `<li class="tileProduct__listItem">${p.size} kvm</li>` : ''}
              </ul>` : ''}
          </div>
        </a>
      </li>`).join('');

  const handleResponse = ({ data, target, trigger }) => {
    const parent = findParent(trigger, config.parentCN);
    const tgt = target;

    if (data.results.length > 0) {
      // replace list content with results
      tgt.innerHTML = createMarkup(data.results);
      // fetch images and display them nicely
      imgLoader.reset();
    } else {
      // show that there's no result
      tgt.innerHTML = parent.dataset.noresult;
    }
  };

  const handleChange = ({ e = false, trigger }) => {
    const target = findTarget({ element: trigger, target: config.targetCN });
    const options = getOptions(trigger);
    const URL = `${endPoint.premise}?${(options.location) ?
      `&location=${options.location}` : ''}${(options.size) ?
      `&min=${options.size[0]}&max=${options.size[1]}` : ''}${(options.type) ?
      `&type=${options.type}` : ''}`;

    // I add the following for when the function is called from range.js
    // in that case there's no 'e' passed through (premise.update)
    if (e) e.preventDefault();

    // remove old result from DOM
    target.innerHTML = '';

    // fetch the data
    axios
      .get(URL)
      .then((response) => {
        if (response.status === 200) {
          handleResponse({ data: response.data, target, trigger });
        }
      });
  };

  const update = ({ trigger }) => {
    // update premise result
    // add timeout to prevent multiple unnecessary requests
    if (config.tolken) {
      clearTimeout(config.tolken);
      config.tolken = false;
    }

    config.tolken = setTimeout(() => {
      config.tolken = false;

      handleChange({ trigger });
    }, 800);
  };

  const getClassname = () => config.triggerCN;

  const build = () => {
    config.triggers.forEach((trigger) => {
      trigger.addEventListener('change', e => handleChange({ e, trigger }));
    });
  };

  const init = () => {
    if (config.triggers.length > 0) {
      build();
    }
  };

  return {
    init,
    update,
    getClassname,
  };
})();

premise.init();

export default premise;
